import { RouterView, createRouter, createWebHashHistory } from "vue-router";
// import { useStore } from "vuex";
// const store = useStore();
import webRoutes from "./webRouter";
import mobileRoutes from "./mobileRouter";
import { nextTick } from "vue";


const router = createRouter({
  history: createWebHashHistory(),
  routes: [],
});

// 监听路由变化
router.afterEach((to, from) => {
  // 动态设置浏览器标题
  // console.log(to, "=====路由变化");
  // document.title = to.meta.title || "ISITM官网";        //modyfied by lishumin
  // nextTick(() => {
  //   if (to.path !== from.path && !to.meta.keepAlive) {
  //     console.log("路由切换后处理滚动和状态重置");
  //     document.body.scrollTop = 0;
  //     window.scrollTo({ top: 0, behavior: "smooth" });
  //   }
  // });
});

export default router;
export { mobileRoutes, webRoutes };
